var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGirlAtHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 407,
    viewBox: "0 0 442 407",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.096 224.469H140.05V237.343H329.096V224.469Z",
    fill: "#F5EBDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.05 12.8113H237.149C256.423 12.8137 274.906 20.4809 288.534 34.1265C302.161 47.7721 309.817 66.2785 309.817 85.5751V224.398H159.347V85.5751C159.347 76.0188 161.227 66.5562 164.88 57.7275C168.533 48.8988 173.887 40.877 180.636 34.1202C187.386 27.3633 195.399 22.0037 204.218 18.3475C213.036 14.6913 222.488 12.8101 232.033 12.8113H232.05Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.341 108.381L209.807 86.1918H220.665L237.864 108.381V225.032H191.341V108.381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.486 93.6838V116.731",
    stroke: "#F4F4F4",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.344 93.6838V116.731",
    stroke: "#F4F4F4",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.584 124.223V221.295",
    stroke: "#F4F4F4",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.529 128.425H194.35V133.414H200.529V128.425Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.494 128.425H204.315V133.414H210.494V128.425Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.708 139.779H194.528V144.768H200.708V139.779Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.664 139.779H204.485V144.768H210.664V139.779Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.877 151.16H194.698V156.149H200.877V151.16Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.843 151.16H204.664V156.149H210.843V151.16Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.02 162.514H194.85V167.494H201.02V162.514Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.003 162.514H204.824V167.494H211.003V162.514Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.226 173.877H195.037V178.865H201.217L201.226 173.877Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.2 173.877H205.012V178.865H211.2V173.877Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.396 185.213H195.207V190.202H201.396V185.213Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.352 185.213H205.163V190.202H211.352V185.213Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.565 196.603H195.377V201.591H201.565V196.603Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.521 196.603H205.342V201.591H211.521V196.603Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.735 207.966H195.547V212.927H201.735V207.966Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.736 207.966H205.485V212.927H211.736V207.966Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.684 128.568H218.496V133.557H224.684V128.568Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.64 128.568H228.46V133.557H234.64V128.568Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.853 139.931H218.665V144.92H224.853V139.931Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.809 139.931H228.63V144.92H234.809V139.931Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.023 151.294H218.879V156.283H225.067L225.023 151.294Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.952 151.294H228.773V156.283H234.952V151.294Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.192 162.657H219.013V167.655H225.192V162.657Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.158 162.657H228.969V167.655H235.158V162.657Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.362 174.02H219.183V179.017H225.362V174.02Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.328 174.02H229.139V179.017H235.328V174.02Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.532 185.383H219.353V190.38H225.532V185.383Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.497 185.383H229.318V190.38H235.497V185.383Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.71 196.755H219.513V201.743H225.684L225.71 196.755Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.667 196.755H229.488V201.743H235.667V196.755Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.88 208.118H219.701V213.106H225.88V208.118Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.845 208.118H229.675V213.106H235.845V208.118Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.747 118.251H228.568V123.24H234.747V118.251Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.503 118.251H194.315V123.24H200.503V118.251Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.789 143.409H248.454V227.911H297.789V143.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.661 157.686H258.196V165.241H265.661V157.686Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.68 157.686H270.215V165.241H277.68V157.686Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.699 157.686H282.234V165.241H289.699V157.686Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.866 174.878H258.401V182.433H265.866V174.878Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.885 174.878H270.42V182.433H277.885V174.878Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.913 174.878H282.448V182.433H289.913V174.878Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.072 192.079H258.607V199.633H266.072V192.079Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.091 192.079H270.626V199.633H278.091V192.079Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.119 192.079H282.654V199.633H290.119V192.079Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.277 209.28H258.812V216.834H266.277V209.28Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.305 209.28H270.84V216.834H278.305V209.28Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.324 209.28H282.859V216.834H290.324V209.28Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.324 65.2362C209.479 65.2362 214.468 60.2409 214.468 54.0789C214.468 47.9169 209.479 42.9216 203.324 42.9216C197.169 42.9216 192.18 47.9169 192.18 54.0789C192.18 60.2409 197.169 65.2362 203.324 65.2362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.568 0H231.612C209.04 -1.24366e-07 187.392 8.97703 171.43 24.9565C155.468 40.9359 146.499 62.609 146.497 85.2085V237.343H322.693V85.2085C322.686 62.6089 313.715 40.9372 297.752 24.9585C281.789 8.97988 260.141 0.0023693 237.568 0ZM228.157 224.469H159.346V117.187H228.157V224.469ZM228.157 104.296H159.346V85.6466C159.347 67.0184 166.483 49.0998 179.284 35.5815C192.085 22.0631 209.577 13.9743 228.157 12.9811V104.296ZM309.817 224.469H241.06V117.187H309.817V224.469ZM309.817 104.296H241.06V12.9811C259.63 13.9876 277.108 22.0821 289.898 35.5991C302.688 49.1161 309.816 67.0272 309.817 85.6466V104.296Z",
    fill: "#1F244D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.798 249.779C383.795 250.255 383.698 250.726 383.512 251.164C382.19 254.186 376.52 254.633 370.877 252.157C366.153 250.092 362.938 246.623 362.84 243.78V281.543H383.842V249.779H383.798Z",
    fill: "#5C63AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.717 241.214C370.082 238.738 364.421 239.185 363.082 242.206C362.866 242.704 362.771 243.247 362.805 243.789C362.939 246.632 366.153 250.1 370.841 252.166C376.485 254.642 382.146 254.195 383.476 251.164C383.665 250.73 383.762 250.261 383.762 249.788C383.807 246.9 380.557 243.324 375.717 241.214Z",
    fill: "#4B518C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.907 262.241C399.764 265.084 396.558 268.553 391.87 270.627C386.218 273.095 380.565 272.656 379.226 269.626C379.038 269.191 378.941 268.723 378.94 268.249V281.534H399.942V262.241H399.907Z",
    fill: "#5C63AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.621 260.668C398.299 257.637 392.629 257.19 386.985 259.666C382.146 261.785 378.895 265.361 378.949 268.249C378.95 268.723 379.047 269.191 379.235 269.626C380.556 272.656 386.226 273.094 391.879 270.627C396.602 268.553 399.808 265.084 399.915 262.241C399.939 261.701 399.838 261.163 399.621 260.668Z",
    fill: "#4B518C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.296 238.416V245.72",
    stroke: "#1F244D",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.405 256.877V264.601",
    stroke: "#1F244D",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.359 407C282.461 407 281.601 406.643 280.966 406.007C280.331 405.372 279.975 404.51 279.975 403.612C279.973 403.25 280.03 402.891 280.144 402.548L290.762 370.158C290.985 369.478 291.417 368.887 291.996 368.468C292.575 368.049 293.271 367.824 293.985 367.824H301.423C301.868 367.823 302.31 367.91 302.721 368.08C303.133 368.249 303.507 368.499 303.822 368.813C304.137 369.128 304.387 369.502 304.558 369.914C304.729 370.325 304.816 370.767 304.816 371.213C304.816 371.792 304.666 372.362 304.379 372.866L286.306 405.265C286.014 405.792 285.587 406.23 285.069 406.535C284.55 406.84 283.96 407.001 283.359 407Z",
    fill: "#1F244D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.588 407C426.486 407 427.348 406.643 427.984 406.008C428.62 405.373 428.978 404.511 428.981 403.612C428.98 403.25 428.919 402.89 428.802 402.548L418.194 370.158C417.97 369.478 417.538 368.887 416.959 368.468C416.381 368.049 415.685 367.824 414.97 367.824H407.523C407.078 367.823 406.636 367.91 406.225 368.081C405.813 368.251 405.439 368.501 405.124 368.817C404.81 369.133 404.561 369.508 404.392 369.921C404.223 370.333 404.137 370.775 404.139 371.221C404.136 371.798 404.284 372.365 404.568 372.866L422.641 405.265C422.935 405.79 423.362 406.227 423.88 406.531C424.398 406.836 424.987 406.998 425.588 407Z",
    fill: "#1F244D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.991 281.552H267.518V381.556H441.991V281.552Z",
    fill: "#1F244D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.142 294.426H280.385V368.674H429.142V294.426Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.599 293.138V369.97",
    stroke: "#1F244D",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.127 336.051C374.607 336.051 376.618 334.038 376.618 331.554C376.618 329.071 374.607 327.057 372.127 327.057C369.646 327.057 367.635 329.071 367.635 331.554C367.635 334.038 369.646 336.051 372.127 336.051Z",
    fill: "#1F244D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.382 336.051C339.863 336.051 341.874 334.038 341.874 331.554C341.874 329.071 339.863 327.057 337.382 327.057C334.902 327.057 332.891 329.071 332.891 331.554C332.891 334.038 334.902 336.051 337.382 336.051Z",
    fill: "#1F244D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.417 171.865L138.085 170.971C150.158 132.663 147.229 141.808 148.175 139.475C150.31 134.218 146.175 125.904 144.425 121.452C150.461 118.868 149.622 129.364 157.239 125.922C164.195 122.82 169.562 116.874 177.42 122.426C178.384 123.115 179.411 125.573 176.786 127.343C170.231 131.813 160.775 139.591 159.462 142.247C157.676 145.93 162.954 136.132 156.417 171.865Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0144 152.412L67.6766 144.991C90.1163 152.715 106.163 189.692 118.405 188.798C126.95 185.722 135.8 183.434 142.264 147.512L160.668 152.483C161.9 196.799 134.942 225.381 118.7 223.727C92.6702 221.081 65.2924 178.302 53.0144 152.412Z",
    fill: "#3D4273"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7208 122.015C57.1311 116.803 54.0236 110.393 54.5772 103.241C56.0685 82.598 85.759 87.1486 91.5363 97.5549C97.3137 107.961 96.6261 134.406 89.1611 136.266C86.1875 137.008 79.8387 135.193 73.3916 131.429L77.4367 159.144H53.5236L61.7208 122.015Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.086 375.379C216.013 354.816 200.065 336.257 192.609 326.11C179.848 308.73 169.231 293.192 165.74 287.211C157.426 272.907 177.803 263.967 183.492 270.43C192.1 280.265 213.995 315.015 244.828 368.397L236.086 375.379Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.437 264.628C182.224 259.81 195.288 266.005 195.279 272.907C195.279 293.55 176.991 390.827 176.045 396.978C175.098 403.129 164.874 404.756 164.285 396.978C163.338 384.641 161.606 341.934 163.338 322.158C164.061 314.005 166.955 292.45 165.615 299.298C168.089 286.71 168.535 277.851 174.437 264.628Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.423 366.886L164.811 283.429C157.917 267.507 187.019 257.414 192.26 264.905C204.154 281.892 235.229 347.387 238.774 352.456L217.423 366.886Z",
    fill: "#5C63AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.389 374.163C229.417 376.391 229.803 378.601 230.532 380.707C231.647 383.029 232.943 385.259 234.408 387.376L284.109 366.957C283.514 362.135 281.749 360.124 278.814 360.922C275.879 361.721 273.432 362.362 271.474 362.845L243.793 361.951C243.669 361.939 243.544 361.954 243.426 361.994C243.308 362.034 243.2 362.098 243.109 362.182C243.017 362.266 242.944 362.369 242.894 362.483C242.844 362.597 242.819 362.72 242.819 362.845L242.935 367.073C241.439 368.909 239.57 370.405 237.453 371.463C235.474 372.082 233.391 372.298 231.327 372.098C231.078 372.086 230.828 372.124 230.594 372.21C230.359 372.297 230.144 372.429 229.962 372.6C229.78 372.771 229.633 372.977 229.532 373.205C229.431 373.434 229.376 373.68 229.371 373.93L229.389 374.163Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.445 391.167C160.578 393.249 160.045 395.454 159.865 397.702C159.962 400.287 160.26 402.861 160.757 405.4H214.075C215.456 400.679 214.656 398.128 211.673 397.747C208.691 397.366 206.211 397.026 204.235 396.728L179.411 385.329C179.298 385.271 179.174 385.237 179.047 385.231C178.92 385.224 178.793 385.245 178.675 385.291C178.556 385.338 178.449 385.409 178.361 385.5C178.272 385.592 178.204 385.701 178.161 385.821L176.572 389.808C174.492 390.947 172.193 391.627 169.83 391.802C167.79 391.613 165.811 391.004 164.017 390.014C163.79 389.908 163.544 389.85 163.294 389.841C163.044 389.832 162.795 389.873 162.561 389.963C162.327 390.052 162.113 390.187 161.932 390.36C161.752 390.533 161.607 390.741 161.508 390.97L161.445 391.167Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.449 279.031C197.449 304.957 185.519 365.384 185.51 371.114H159.856C163.606 317.175 164.936 289.92 163.847 289.348C162.213 288.454 96.6795 296.098 77.0258 296.098C48.6925 296.098 36.9681 277.654 36.0127 243.503L92.0005 253.936C104.912 247.937 167.079 245.765 188.439 253.936C197.913 255.769 197.449 271.932 197.449 279.031Z",
    fill: "#5C63AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.198 250.995H132.263L145.658 208.654C146.054 207.408 146.836 206.32 147.891 205.549C148.945 204.777 150.218 204.362 151.524 204.363H201.288C202.258 204.361 203.215 204.589 204.081 205.029C204.946 205.468 205.695 206.106 206.267 206.891C206.839 207.675 207.218 208.584 207.372 209.543C207.527 210.502 207.452 211.484 207.155 212.409L196.082 247.428C195.746 248.461 195.093 249.362 194.216 250.002C193.34 250.642 192.283 250.99 191.198 250.995Z",
    fill: "#1F244D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.108 246.229C97.5008 249.484 98.5634 251.54 100.492 252.148C100.85 252.265 101.223 252.326 101.599 252.327H191.198C192.289 252.325 193.351 251.979 194.233 251.337C195.115 250.694 195.772 249.789 196.109 248.751L196.457 246.265L98.108 246.229Z",
    fill: "#1F244D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.161 224.031C180.786 222.154 174.571 227.107 174.125 227.518C173.884 227.107 170.651 222.154 168.276 224.031C166.213 225.658 170.732 232.918 171.946 234.759C171.993 234.812 172.05 234.856 172.113 234.887C172.177 234.918 172.246 234.936 172.316 234.94C172.387 234.944 172.457 234.934 172.524 234.911C172.591 234.888 172.652 234.851 172.705 234.804L172.75 234.759C174.955 232.9 183.349 225.64 182.161 224.031Z",
    fill: "#F2463A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.589 223.45C175.089 221.859 175.911 220.705 176.429 220.866C176.947 221.027 176.965 222.449 176.429 224.04C175.893 225.631 175.116 225.452 174.589 225.292C174.063 225.131 174.098 225.041 174.589 223.45Z",
    fill: "#F2463A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.833 247.097L124.227 238.934C126.251 230.996 128.668 226.999 131.478 226.946C133.638 225.909 129.879 235.939 133.978 235.072C138.076 234.205 148.069 226.534 149.792 228.09C152.337 230.397 150.069 237.468 147.39 240.991C142.38 247.571 138.237 249.814 128.004 252.765C122.646 254.302 116.857 257.39 110.636 262.027L109.833 247.097Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.403 202.307C105.278 218.068 106.6 223.378 108.511 243.306C109.064 253.954 107.814 264.092 103.591 273.354C94.9112 292.387 44.1025 274.757 27.0204 278.226C16.305 242.385 37.0036 227.813 37.0214 204.917C37.0214 179.795 56.5858 141.129 59.4611 141.129H85.6959C87.1425 160.279 94.429 181.422 100.403 202.307Z",
    fill: "#3D4273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.527 88.266C86.0443 81.3999 70.9893 76.8226 59.0595 85.5124C47.1297 94.2022 48.0851 108.408 48.5405 113.906C48.5405 113.906 35.7356 109.785 26.5919 119.396C23.9452 122.145 22.0177 125.506 20.9802 129.18C19.9428 132.855 19.8276 136.729 20.6449 140.459C20.6449 140.459 3.79497 139.985 0.517854 155.567C-1.33948 164.427 2.13409 170.319 5.99163 173.975C8.25916 176.096 10.9032 177.773 13.787 178.919C13.787 178.919 27.7884 171.767 30.0744 166.251C33.7801 157.364 27.8777 147.03 41.6827 145.492L45.692 145.054C55.2644 143.981 59.9792 143.167 63.551 138.304C67.6675 132.815 64.9708 121.684 64.9708 121.684C64.9708 121.684 54.3001 119.315 55.8181 110.697C57.1932 102.919 66.337 102.919 71.3643 108.408C71.3643 108.408 79.1419 106.62 86.464 98.3415C86.464 98.3415 91.8217 99.5931 95.4649 98.9763C94.8577 94.8549 93.7594 91.0642 91.527 88.266Z",
    fill: "#1F244D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.083 358.625H47.0045V366.197H114.083V358.625Z",
    fill: "#1F244D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.12 397.908L108.52 300.594H118.681C119.747 300.594 120.769 300.171 121.523 299.416C122.276 298.662 122.7 297.638 122.7 296.571C122.7 295.504 122.276 294.481 121.523 293.727C120.769 292.972 119.747 292.548 118.681 292.548H42.4952C41.4295 292.548 40.4075 292.972 39.6539 293.727C38.9003 294.481 38.4769 295.504 38.4769 296.571C38.4769 297.638 38.9003 298.662 39.6539 299.416C40.4075 300.171 41.4295 300.594 42.4952 300.594H52.5766L35.9589 397.908C35.8879 398.348 35.905 398.799 36.0092 399.233C36.1134 399.667 36.3026 400.076 36.566 400.436C36.8293 400.796 37.1615 401.1 37.5432 401.331C37.9249 401.561 38.3485 401.714 38.7895 401.779C38.9798 401.793 39.1708 401.793 39.361 401.779C40.1436 401.784 40.9042 401.52 41.5166 401.032C42.129 400.544 42.5562 399.861 42.7274 399.097L64.7386 300.514H96.3489L118.369 399.097C118.539 399.862 118.965 400.546 119.578 401.034C120.191 401.522 120.952 401.785 121.735 401.779C122.182 401.785 122.626 401.703 123.041 401.537C123.456 401.371 123.834 401.125 124.154 400.813C124.474 400.501 124.73 400.129 124.906 399.718C125.083 399.307 125.176 398.865 125.182 398.417C125.173 398.246 125.152 398.076 125.12 397.908Z",
    fill: "#1F244D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8987 161.182L66.5334 162.228C76.9094 183.595 70.5605 224.657 79.3293 233.239C87.6158 241.357 98.9206 241.536 117.664 240.642L121.646 258.799C100.805 271.316 65.1315 270.788 54.8179 258.084C38.3341 237.781 49.2191 188.154 58.8987 161.182Z",
    fill: "#3D4273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.561 198.623C335.483 200.799 333.819 202.631 331.757 203.911C329.695 205.191 327.316 205.87 324.89 205.87C322.464 205.87 320.086 205.191 318.024 203.911C315.962 202.631 314.298 200.799 313.219 198.623C313.219 198.623 289.467 252.997 312.809 281.588H336.918C360.278 252.961 336.561 198.623 336.561 198.623Z",
    fill: "#4B518C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.881 205.838C327.305 205.832 329.68 205.15 331.74 203.87C333.799 202.589 335.462 200.76 336.543 198.588H313.201C314.284 200.763 315.95 202.593 318.013 203.873C320.075 205.154 322.454 205.834 324.881 205.838Z",
    fill: "#1F244D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.88 130.839L323.3 201.77",
    stroke: "#1F244D",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.87 159.43L321.88 201.18",
    stroke: "#1F244D",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.042 176.089C352.886 172.731 358.494 168.249 357.568 166.079C356.641 163.909 349.53 164.872 341.685 168.23C333.841 171.588 328.233 176.07 329.159 178.24C330.086 180.41 337.197 179.447 345.042 176.089Z",
    fill: "#1F244D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.433 185.033C318.231 182.913 311.143 178.273 301.6 174.671C292.057 171.068 283.674 169.867 282.875 171.987C282.077 174.108 289.165 178.747 298.708 182.35C308.251 185.953 316.634 187.154 317.433 185.033Z",
    fill: "#1F244D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.457 162.418C335.98 158.253 339.603 153.742 338.549 152.342C337.496 150.942 332.165 153.183 326.643 157.348C321.12 161.513 317.497 166.025 318.55 167.425C319.604 168.825 324.935 166.583 330.457 162.418Z",
    fill: "#1F244D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.587 139.448L324.934 205.051",
    stroke: "#1F244D",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.898 133.065C312.088 133.065 314.228 132.415 316.049 131.197C317.87 129.979 319.289 128.247 320.127 126.222C320.965 124.196 321.185 121.967 320.757 119.817C320.33 117.666 319.276 115.691 317.727 114.141C316.179 112.59 314.206 111.534 312.058 111.107C309.91 110.679 307.684 110.898 305.66 111.737C303.637 112.577 301.908 113.997 300.691 115.82C299.474 117.643 298.825 119.787 298.825 121.979C298.827 124.919 299.995 127.737 302.071 129.816C304.147 131.894 306.962 133.063 309.898 133.065Z",
    fill: "#5C63AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.238 114.8C319.278 117.219 319.423 119.929 318.648 122.444C317.873 124.96 316.228 127.118 314.009 128.529C311.789 129.941 309.14 130.516 306.536 130.149C303.932 129.783 301.543 128.5 299.798 126.53C300.426 128.006 301.367 129.327 302.558 130.401C303.749 131.475 305.159 132.277 306.69 132.752C308.222 133.226 309.838 133.362 311.427 133.15C313.016 132.937 314.54 132.381 315.893 131.521C317.247 130.66 318.397 129.515 319.265 128.166C320.13 126.815 320.693 125.292 320.917 123.703C321.14 122.114 321.018 120.495 320.559 118.957C320.095 117.42 319.303 116.002 318.238 114.8Z",
    fill: "#4B518C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.588 141.719C340.225 141.72 341.843 141.358 343.324 140.657C344.804 139.957 346.111 138.936 347.15 137.668C348.189 136.401 348.934 134.918 349.331 133.327C349.728 131.737 349.767 130.078 349.446 128.47C349.019 126.32 347.967 124.345 346.42 122.794C344.874 121.243 342.904 120.184 340.757 119.753C338.427 119.288 336.01 119.586 333.862 120.603C331.714 121.619 329.95 123.301 328.83 125.398C327.709 127.496 327.293 129.899 327.641 132.252C327.99 134.605 329.085 136.783 330.765 138.465C332.84 140.543 335.653 141.713 338.588 141.719Z",
    fill: "#F89790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.937 123.454C347.948 125.87 348.072 128.567 347.287 131.066C346.502 133.564 344.858 135.704 342.648 137.105C340.437 138.506 337.802 139.079 335.21 138.72C332.619 138.362 330.237 137.097 328.489 135.148C329.116 136.631 330.059 137.958 331.251 139.039C332.443 140.12 333.856 140.928 335.391 141.406C337.7 142.118 340.177 142.055 342.447 141.228C344.717 140.4 346.654 138.852 347.964 136.82C348.83 135.469 349.394 133.947 349.616 132.357C349.838 130.767 349.713 129.148 349.25 127.612C348.792 126.073 348.002 124.654 346.937 123.454Z",
    fill: "#F2463A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.37 166.313C305.935 166.316 308.42 165.427 310.404 163.8C312.387 162.172 313.746 159.906 314.247 157.389C314.749 154.871 314.362 152.257 313.154 149.992C311.946 147.727 309.991 145.952 307.622 144.969C305.253 143.986 302.616 143.856 300.162 144.602C297.708 145.347 295.589 146.922 294.164 149.057C292.74 151.192 292.099 153.755 292.352 156.31C292.604 158.865 293.734 161.254 295.548 163.068C296.574 164.098 297.793 164.915 299.136 165.472C300.478 166.029 301.917 166.315 303.37 166.313Z",
    fill: "#F89790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.746 148.058C312.785 150.476 312.931 153.186 312.156 155.702C311.381 158.218 309.736 160.375 307.517 161.787C305.297 163.199 302.648 163.773 300.044 163.406C297.44 163.04 295.051 161.757 293.306 159.787C293.934 161.27 294.876 162.597 296.068 163.678C297.26 164.759 298.673 165.567 300.209 166.045C301.74 166.517 303.355 166.652 304.943 166.439C306.53 166.226 308.053 165.671 309.406 164.812C310.759 163.946 311.91 162.8 312.781 161.45C314.088 159.415 314.694 157.009 314.507 154.597C314.32 152.186 313.35 149.902 311.746 148.094V148.058Z",
    fill: "#F2463A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 442,
    height: 407,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlAtHome);
export default __webpack_public_path__ + "static/media/girl-at-home.1340b70ea322fbfba7c672a7cdb44b9f.svg";
export { ForwardRef as ReactComponent };